module.exports = __webpack_public_path__ + "d1080d34913bfd2dc4fefbbe1bbe058d.svg";